export const filterRefundSchema = [
  {
    id: "operationStatus",
    label: "Status",
    type: "text",
    multiselector: true,
    displayLogo: false,
    showTitleType: false,
    uniqueType: false,
    items: [
      { label: "Received", value: "Received" },
      { label: "Batched", value: "Batched" },
      { label: "Redirection", value: "Redirection" },
      { label: "Posted", value: "Posted" },
      { label: "Approved", value: "Approved" },
      { label: "Rejected", value: "Rejected" },
      { label: "Failed", value: "Failed" },
      { label: "Settled", value: "Settled" },
      { label: "Reconciled", value: "Reconciled" },
      { label: "Expired", value: "Expired" },
    ],
  },
  {
    id: "pspCode",
    label: "Processor",
    type: "text",
    multiselector: true,
    displayLogo: true,
    showTitleType: false,
    uniqueType: false,
    items: ["data is updated from api"],
  },
  {
    id: "timestamp",
    label: "Date",
    type: "date",
    displayLogo: false,
    showTitleType: false,
    uniqueType: false,
    multiselector: false,
    items: [],
  },
  {
    id: "paymentMethodType",
    label: "Payment Category",
    type: "text",
    multiselector: true,
    displayLogo: false,
    showTitleType: false,
    uniqueType: false,
    items: ["data is updated from api"],
  },
  // {
  //   id: "countryCode",
  //   label: "Country",
  //   type: "text",
  //   multiselector: true,
  //   items: ["data is updated from api"],
  // },
  // {
  //   id: "currencyCode",
  //   label: "Currency",
  //   type: "text",
  //   multiselector: true,
  //   items: ["data is updated from api"],
  // },
];
